// extracted by mini-css-extract-plugin
module.exports = {"shopItem":"ShopItem_shopItem__1kPhI","data":"ShopItem_data__3KvXd","taking":"ShopItem_taking__3XJSj","not_taking":"ShopItem_not_taking__2YqzH"};